import { Text } from '@dixa/lib-shared-habla';
import { FilterInfo } from 'lib-shared-types-api';

import { FilterLink } from '../shared';

type FailedFilterItemProps = {
  filter: FilterInfo;
  reasonText: string;
};

/**
 * Displays a filter that didn't match or had no agent assigned. Shows subdued
 * text with reason.
 */
export const FailedFilterItem = ({
  filter,
  reasonText,
}: FailedFilterItemProps): JSX.Element => {
  return (
    <Text.Paragraph variant="3" subdued>
      Filter: <FilterLink filter={filter} /> {reasonText}
    </Text.Paragraph>
  );
};
